<app-kontable #table data-testid="table" title="{{ 'customerOblivion.oblivionTitle' | translate }}"
  [columns]="[
    {field: 'id', title: 'ID'},
    {field: 'customerId', title: 'customerOblivion.customerId'},
    {field: 'customerHostId', title: 'customerOblivion.customerHostId'},
    {field: 'cardId', title: 'customerOblivion.cardId'},
    {field: 'customerCode', title: 'customerOblivion.customerCode'}
  ]"
  [service]="customerOblivionService"
  [paginationType]="paginationType"
  [showInfoButton]="false"
  [showEditButton]="false"
  [showDeleteButton]="false"
  [showRecoverButton]="true"
  [showDetailsButton]="false"
  [showAddButton]="false"
  [showGlobalFilter]="false"
  [additionalRowCommands]="actions"
  [(fireNewDataAvailable)]="newDataAvailable"
>
</app-kontable>


<ng-template #actions data-testid="actions" let-row>
  <p-button *ngIf="row.customerJson" pTooltip="{{ 'customerOblivion.viewCustomerJson' | translate }}" icon="fa fa-eye" styleClass="ui-button-info"
  (click)="openDialog(row)" >
  </p-button>

  <p-button *ngIf="row.customerJson" pTooltip="{{ 'customerOblivion.recoverCustomer' | translate }}" icon="fa fa-undo" styleClass="ui-button-info" (click)="recoverCustomer(row.customerId)">
  </p-button>
</ng-template>

<p-dialog class = "oblivion-dialog"
  header="{{ 'customerOblivion.viewCustomerJson' | translate}}"
  [(visible)]="showDialog"
  [modal]="true"
  [minWidth]="600"
  [draggable]="false"
  [resizable]="false"
  [responsive]="true"
  [dismissableMask]="true"
  (onHide)="closeDialog()" >
  <div>
    <pre>{{customerJson | json}}</pre>
  </div>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-oblivion/customer-oblivion.component.html